import { SignIn, SignUp } from "@clerk/react";
import QuickSignIn, { CLASSIC } from "@/components/auth/QuickSignIn";
import { Code2, MessageSquareText, Share2 } from "lucide-react";
import { Logo } from "@/components/layout/Logo";

const POINTS = [
  { icon: MessageSquareText, text: "Genera e modifica demo con l'AI, sezione per sezione" },
  { icon: Code2, text: "Controllo totale: editor visuale e codice HTML, CSS, JS e React" },
  { icon: Share2, text: "Condividi ogni prototipo con un link pubblico dedicato" },
];

export default function AuthPage({ mode = "sign-in" }) {
  const qs = window.location.search;
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.05fr_1fr] bg-slate-50" data-testid={`${mode}-page`}>
      <aside className="hidden lg:flex flex-col justify-between bg-navy-900 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 studio-grid-bg" />
        <div className="relative"><Logo dark height={30} /></div>
        <div className="relative max-w-md">
          <p className="text-xs uppercase tracking-[0.22em] text-sky-400">Strumento interno</p>
          <h1 className="mt-4 text-4xl font-semibold leading-tight tracking-tight">Prototipi interattivi, pronti per l'incontro commerciale.</h1>
          <ul className="mt-10 space-y-4">
            {POINTS.map(({ icon: Icon, text }) => (
              <li key={text} className="flex gap-3 text-sm text-slate-300"><Icon size={18} className="text-sky-400 shrink-0" />{text}</li>
            ))}
          </ul>
        </div>
        <p className="relative text-xs text-slate-500">© MUSORA · Accesso riservato</p>
      </aside>
      <main className="flex flex-col items-center justify-center p-6 gap-8">
        <div className="lg:hidden"><Logo height={30} /></div>
        {mode === "sign-up"
          ? <SignUp routing="path" path="/sign-up" signInUrl={`/sign-in${qs}`} />
          : mode === "classic" ? <SignIn routing="path" path={CLASSIC} signUpUrl={`/sign-up${qs}`} withSignUp />
          : <QuickSignIn />}
        <p className="text-sm text-slate-600" data-testid={`${mode}-switch`}>{mode === "sign-up"
          ? <>Hai già un account? <a href={`/sign-in${qs}`} className="font-medium text-sky-700 hover:underline" data-testid="goto-sign-in">Accedi</a></>
          : <>Non hai un account? <a href={`/sign-up${qs}`} className="font-medium text-sky-700 hover:underline" data-testid="goto-sign-up">Registrati</a> <span className="text-slate-400">(serve un invito per entrare in uno spazio)</span></>}</p>
      </main>
    </div>
  );
}
